import * as React from 'react';
import { SelectMultiple, SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { FilterCommonProps, FilterCommonValues } from './types';

export class FilterCodeHierarchy extends React.PureComponent<FilterCommonProps<string>, { loadedOptions: LoadOptions }> {

  public state: Readonly<{ loadedOptions: LoadOptions }> = {
    loadedOptions: {}
  };

  private onChange = (values: FilterCommonValues<string>[]) => {
    this.props.onChange(this.props.id, values);
  };

  private onLoadOptions = (options: LoadOptions) => {

    const { id, onLoadOptions, optionsEndpoint, optionsParams } = this.props;

    onLoadOptions(
      id,
      optionsEndpoint,
      options,
      optionsParams
    );
    this.setState({ loadedOptions: options });
    return;
  };

  public render() {

    const {
      id, label, values, options, fetchingOptions, isHierarchy = true, optionsParams, translation,
      meatballPanelConfiguration, locale, includeDisabledLabel, allowQuerySearch
    } = this.props;

    const selectComponentProps = {
      componentId: id,
      className: undefined,
      label: label ? { text: label } : undefined,

      valueItems: values || [],
      onChange: this.onChange,

      options,
      fetching: fetchingOptions,
      loadOptions: this.state.loadedOptions,
      onLoadOptions: this.onLoadOptions,

      minLength: optionsParams?.minLength,
      placeholder: translation?.search,

      displaySelectAll: true,
      meatballPanelConfiguration,
      locale,
      includeDisabledLabel,
      allowQuerySearch
    };

    return isHierarchy
      ? <SelectMultipleHierarchy {...selectComponentProps} descriptionAllLevels={true} />
      : <SelectMultiple {...selectComponentProps} />;
  }
}
